import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-2 p-6 rounded-xl border border-gray-lp-1300" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row gap-x-4"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-full" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row mt-4 gap-x-4"
}
const _hoisted_5 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "Shipment ID", -1)
const _hoisted_7 = { class: "ml-1 relative" }
const _hoisted_8 = { class: "opacity-75" }
const _hoisted_9 = { class: "flex flex-row gap-x-4" }
const _hoisted_10 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_11 = { class: "text-gray-lp-500 font-normal" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row mt-4 gap-x-4" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-full" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isSttRetail)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.paymentMethod'),
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                class: "my-2",
                "model-value": _ctx.checkoutPaymentMethod,
                disabled: "",
                disableBackground: ""
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }, 8, ["label"]),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.formType === 'client' && !_ctx.isSttForeign)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.clientName'),
            asterisk: "",
            style: {"margin-right":"12px"},
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                isFirstInput: true,
                options: [],
                class: "my-2",
                placeholder: "Pilih Client",
                modelValue: _ctx.modelValue.sttClient.clientName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.sttClient.clientName = $event)),
                isDisabled: true,
                disabledBackground: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (!_ctx.isSttForeign)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "w-full mr-0"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode("div", _hoisted_7, [
                      _createVNode("img", {
                        onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenTooltipShipmentID = true)),
                        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpenTooltipShipmentID = false)),
                        src: 
                _ctx.isOpenTooltipShipmentID
                  ? require('@/app/ui/assets/svg/info-red.svg')
                  : require('@/app/ui/assets/svg/info.svg')
              ,
                        alt: ""
                      }, null, 40, ["src"]),
                      _withDirectives(_createVNode(_component_Tooltip, {
                        title: "Shipment ID",
                        message: "Isi Shipment ID dengan kode booking marketplace yang tertera pada paket (XYZ00xxx).",
                        footer: "",
                        style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.6em"}
                      }, null, 512), [
                        [_vShow, _ctx.isOpenTooltipShipmentID]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.modelValue.sttShipmentId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.sttShipmentId = $event)),
                      disabled: true,
                      disableBackground: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_DataWrapper, { class: "w-full mr-4" }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_10, [
            _createVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.manualSttNumber")) + " ", 1),
              _createVNode("span", _hoisted_11, "(" + _toDisplayString(_ctx.$t("optional")) + ")", 1)
            ])
          ]),
          _createVNode(_component_lp_input, {
            class: "my-2",
            isFirstInput: _ctx.isFirstInput,
            disabled: true,
            errorIcon: false,
            modelValue: _ctx.modelValue.sttNo,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.sttNo = $event)),
            disableBackground: ""
          }, null, 8, ["isFirstInput", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('bookingShipment.column.externalRefNumber'),
        optional: "",
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lp_input, {
            modelValue: _ctx.modelValue.sttNoRefExternal,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.sttNoRefExternal = $event)),
            placeholder: "DOR00989",
            onChange: _ctx.checkFocus,
            disabled: true,
            showMaxLength: true,
            maxLength: 100,
            disableBackground: ""
          }, null, 8, ["modelValue", "onChange"])
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _hoisted_12
  ]))
}